import { range } from '@btime/helpers'
import moment from 'moment'

export const MONTH_NUMBERS = range(1, 12)
export const YEAR_NUMBERS = range(1900, moment().format('YYYY'))

export const MONTH_OPTIONS = MONTH_NUMBERS.map(month => ({ label: month, value: month }))
